import {
  shape,
  string,
  objectOf,
} from 'prop-types';

export const clientProfileEntryType = shape({
  clientName: string.isRequired,
  clientNumber: string.isRequired,
  clientType: string.isRequired,
});

export const clientProfileEntriesType = objectOf(clientProfileEntryType);


// WEBPACK FOOTER //
// ./src/prop-types/clientProfileEntryTypes.js